import api from '@/apis/tax/organizationHaveRiskAPI.js';
import Crud from '@/stores/crudBaseCache.js';

var crud = new Crud('organizationHaveRisk', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_organization_have_risk',
    field: {
      key: 'id',
    },
  },
  activeStatusNNTs: []
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
